import { InputNumber, type InputNumberProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { inputBlurOnWheel } from '@/utils/inputBlurOnWheel';
import { getLocaleInputNumberProps } from '@/utils/localeInputNumberProps';

/** Ant Design InputNumber with locale-aware decimal separator and scroll protection. */
export const InputNumberInput = (props: InputNumberProps) => {
  const { i18n } = useTranslation();
  const localeProps = getLocaleInputNumberProps(i18n.language);

  return <InputNumber {...props} {...localeProps} onWheel={inputBlurOnWheel} />;
};
